import React, { useEffect, useState, useContext } from "react";
import { Grid, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import { NavLink } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import SendIcon from "@mui/icons-material/Send";
import { useNavigate } from "react-router-dom";
import { getCustomerProfile } from "_models/redux/customer-profile/action";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import { cleanGetProfile } from "../../../../../../_models/redux/customer-profile/clean";
import { LoadersContext } from "_models/context/app";
import CircularProgress from "@mui/material/CircularProgress";

const Modal = (props) => {
    const { modalOpen, setOpenModal } = props || {};

    const [directNumber, setDirectNumber] = useState("");

    const [isLoading, setloading] = useState(false);
    const loadersContext = useContext(LoadersContext);
    const { setIsScreenLoading } = loadersContext || {};

    const navigate = useNavigate();

    const [validationError, setValidationError] = useState(false);
    const [textError, setTextError] = useState("");

    const onInputChange = ({ target }) => {
        const { value } = target;
    };

    const {
        register,
        handleSubmit,

        formState: { errors },
    } = useForm();

    const onSubmit = (e) => {};

    useEffect(() => {
        return () => {};
    }, [modalOpen]);

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container className="modalBackground">
                <Grid item xs={4} className="modalContainer">
                    <Grid container className="title">
                        <Grid item xs={9}>
                            <h4>Buscar envío por número de orden</h4>
                        </Grid>
                        <Grid item xs={3} className="titleCloseBtn">
                            <button
                                onClick={() => {
                                    setOpenModal(false);
                                }}
                            >
                                <CloseIcon />
                            </button>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="body">
                        <TextField
                            variant="standard"
                            // error={validationError}
                            helperText={textError}
                            fullWidth
                            type="text"
                            className="form-control"
                            placeholder="Número de rastreo"
                            value={directNumber}
                            onChange={onInputChange}
                        />
                    </Grid>
                    <span>
                        {errors?.directNumber && (
                            <p className="required-incidence">
                                {errors.directNumber.message}
                                {/* {response?.data?.detail} */}
                            </p>
                        )}
                    </span>
                    <center>
                        {" "}
                        {/* {isLoading ? (
                            <CircularProgress />
                        ) : response?.status >= 300 ? (
                            <span className="required-incidence">
                                {response?.data?.detail}
                            </span>
                        ) : null} */}
                    </center>

                    <Grid item xs={12} className="footer">
                        <button
                            onClick={() => {
                                setOpenModal(false);
                            }}
                            id="cancelBtn"
                        >
                            Cancelar
                        </button>

                        <LoadingButton
                            size="small"
                            type="submit"
                            isLoading={true}
                            // endIcon={<SendIcon />}
                            loadingPosition="end"
                            variant="contained"
                        >
                            Buscar
                        </LoadingButton>
                    </Grid>
                </Grid>
            </Grid>
        </form>
    );
};

const mapStateToProps = (state) => ({
    customerProfileReducer: state.customerProfile,
});
const mapDispatchToProps = {
    getCustomerProfile,
    cleanGetProfile,
};

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
